import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { Icon } from 'semantic-ui-react';

const FavouriteStar = ({
  asset,
  onClick,
}) => {
  //
  const isStory = _.get(asset, 'type') === 'stories';

  let favourite = isStory ? _.get(asset, 'favourite') : _.get(asset, 'trackedAsset.favourite');
  let assetId = isStory ? _.get(asset, 'id') : _.get(asset, 'trackedAsset.id');

  if (_.isNil(assetId)) {
    assetId = _.get(asset, 'id');
  }

  if (_.isNil(favourite)) {
    favourite = _.get(asset, 'favourite');
  }

  const assetType = isStory ? 'stories' : 'trackedAsset';
  return (
    <Icon
      name={favourite ? 'star' : 'star empty'}
      color={favourite ? 'orange' : 'gray'}
      onClick={() => onClick({ assetId, favourite, assetType })}
    />
  );
};

FavouriteStar.propTypes = {
  asset: PropTypes.object.isRequired,
  onClick: PropTypes.func.isRequired,
};


export default FavouriteStar;



/** WEBPACK FOOTER **
 ** ./src/components/favourite-star/index.js
 **/